import { render, staticRenderFns } from "./FontalDcopsStaffTable.vue?vue&type=template&id=ddb8adca&scoped=true"
import script from "./FontalDcopsStaffTable.vue?vue&type=script&lang=js"
export * from "./FontalDcopsStaffTable.vue?vue&type=script&lang=js"
import style0 from "./FontalDcopsStaffTable.vue?vue&type=style&index=0&id=ddb8adca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8adca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb8adca')) {
      api.createRecord('ddb8adca', component.options)
    } else {
      api.reload('ddb8adca', component.options)
    }
    module.hot.accept("./FontalDcopsStaffTable.vue?vue&type=template&id=ddb8adca&scoped=true", function () {
      api.rerender('ddb8adca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staffManage/resource/components/FontalDcopsStaffTable.vue"
export default component.exports